import { SliceStatus } from 'src/redux/types'

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Workflow } from '../../consts'
import { AsyncTask } from '../async-processing/consts'
import { addAsyncExtraReducers } from '../async-processing/utils'
import { addErrorExtraReducers } from '../error/utils'

const workflow = Workflow.project

export interface ProjectState extends SliceStatus {
  id: number | null
  drawerOpen: boolean
  // TODO: create an interface for params that all slices have
}

const initialState: ProjectState = {
  id: null,
  drawerOpen: false,
  // Other
  isProcessing: false,

  error: null,
  errors: {},
  runtimeError: null,
}

export const projectSlice = createSlice({
  name: workflow,
  initialState,
  reducers: {
    activateProject: (state, { payload }: PayloadAction<number>) => {
      state.id = payload
    },
    deactivateProject: (state) => {
      state.id = null
    },
    toggleDrawer: (state) => {
      state.drawerOpen = !state.drawerOpen
    },
  },
  // TODO: Typescript for extrareducers
  extraReducers: (builder) => {
    addErrorExtraReducers(builder, { workflow })
    addAsyncExtraReducers(builder, { workflow, handlers })
  },
})

const handlers = {}

// Action creators are generated for each case reducer function
export const { toggleDrawer, deactivateProject, activateProject } = projectSlice.actions

export default projectSlice.reducer
